import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import sitedata from '../../sitedetails.json'
import { useDispatch, useSelector } from "react-redux";
import { createCourseAction } from "../../redux/actions/adminAction";
import { Toaster, toast } from "react-hot-toast";

const CreateCourse = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [creator, setCreator] = useState("");
  const [imagePreview, setImagePreview] = useState("https://www.contentviewspro.com/wp-content/uploads/2017/07/default_image.png")
  const categorylist = sitedata.coursecategory;
  const [image, setImage] = useState()

  const dispatch = useDispatch()
  const { loading, error, message} = useSelector( state => state.admin)
  const { user } = useSelector( state => state.user)



  useEffect( ()=> {

    if (error) {
      toast.error(error);
      dispatch({
        type: "clearError",
      });
    }

    if (message?.message) {
      toast.success(message?.message);
      dispatch({
        type: "clearMessage",
      });
    }
    if (loading) {
      toast.success('Sending Request');
      dispatch({
        type: "clearMessage",
      });
    }

  }, [dispatch, error, loading, message?.message])


  const changeImageHandler = (e) => {
    // console.log(e.target.files[0])
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file)

    reader.onloadend = () => {
      setImagePreview(reader.result)
      setImage(file)
    //   console.log(reader.result)
    //   console.log(file)
    }
    
  }

  const submitHandler = async(e) => {
    e.preventDefault();

    

    const myForm = new FormData();

    myForm.append('title', title);
    myForm.append('description', description);
    myForm.append('category', category);
    myForm.append('createdBy', creator);
    myForm.append('file', image);

    // console.log(myForm)
    if(!image) {
      toast.error('Thumbnail is not selected')
    }
    else {
      await dispatch(createCourseAction(myForm))
      
    }
    

  }


  // const createCourseHandler = (e) => {
  //   e.preventDefault();
  //   const data = {
  //     title,
  //     description,
  //     category,
  //     creator,
  //     imagePreview
  //   };
  //   console.log(data)
   
  //   // dispatch(registerAction(name, emailaddress, password));
  // };


  return (
    <>
    <Toaster/>
      <div className="grid grid-cols-5">
        <div className="">
          <AdminSidebar />
        </div>
        <div className="col-span-3 py-20">
          <div className=" px-20">
            {/* form  */}
            <h1 className="font-semibold text-2xl my-6"> Create Course</h1>

            <form action="" 
            onSubmit={(e) => {
              submitHandler(e);
              }}
              >
              <input
                className="my-3 w-full py-2 font-semibold px-6 text-blue-700 bg-white  border-b-2 outline-0 	focus:border-blue-700	"
                type="text"
                value={title}
                placeholder="Course Title"
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />

              <input
                className="my-3 w-full py-2 font-semibold px-6 text-blue-700 bg-white  border-b-2 outline-0 	focus:border-blue-700	"
                type="text"
                value={description}
                placeholder="Course Description"
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
              />

              <select
                className="my-3 w-full py-2 font-semibold px-6 text-blue-700 bg-white  border-b-2 outline-0 	focus:border-blue-700		"
                type="text"
                // value={category}
                placeholder="Category"
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
              >

                <option  value="">Category</option>
                {categorylist.map( (cat) => (
                    <option className="font-semibold" key={cat} value={cat}>{cat}</option>
                ))}
              </select>

              <input
                className="my-3 w-full py-2 font-semibold px-6 text-blue-700 bg-white  border-b-2 outline-0 	focus:border-blue-700	"
                type="text"
                value={creator}
                placeholder="Creator Name"
                onChange={(e) => {
                  setCreator(e.target.value);
                }}
              />

              <div className="flex">
                <div>
                  <label className="font-semibold" htmlFor="profile">Thumnail</label>
                  <input
                    onChange={(e) => {
                        changeImageHandler(e);
                    }}
                    accept="image/*"
                    className="w-full my-2  cursor-pointer"
                    id="profile"
                    type="file"
                  />
                </div>

                <div className="">
                    <img src={imagePreview}  alt='thumnail' className="mx-10 w-[200px] h-[100px]"/>
                </div>
              </div>

              <button disabled={loading} className={` my-4 ease-linear ${loading ? 'bg-yellow-100 text-gray-600' : 'bg-brand_yellow text-black  transition hover:-translate-y-1'} px-6 py-1 font-outfit font-semibold`}>
                Create Course
              </button>
            </form>
          </div>
        </div>
        <div className="">
          {/* profile  */}
          <div className=" bg-[#F6F6F6] text-center px-3 items-center text-[#141414] font-bold mx-2 text-base my-6">

            <div className=" px-3 py-4">


            </div>
            <h1 className="py-2">Profile</h1>
              <img alt='profile'  className="h-[70px] rounded-full py-1 mx-auto" src={user?.avatar?.url}></img>

              <div>
              <div>
              <h1 className="capitalize py-1 ">{user?.name}</h1>
            <h1 className="capitalize py-1  " >{user?.role} </h1>

              </div>

              <div>
              <h1 className="lowercase py-1" >{user?.email} </h1>
            
            <h1 className="capitalize py-1" >{user?.subscription?.status} </h1>

              

              </div>
            </div>

            
            

          </div>
        </div>
      </div>
    </>
  );
};

export default CreateCourse;
